import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import LinkCart from "../Components/Home/LinkCart";
import Building from "./../assets/resources/building_front.webp";
import Flushing from "./../assets/resources/neighborhood2.png";
import Availability from "./../assets/resources/Lobby_view3.jpg";
import Gallery from "./../assets/resources/Restroom_view1.jpg";
import PanoramaViewer from "../Components/Home/PanoramaViewer";
import "./building_page.css";
import { Helmet } from "react-helmet";

export default function Home() {
  const [isScrolledToSection, setIsScrolledToSection] = useState({
    section1: false,
    section2: false,
    section3: false,
    section4: false,
    section5: false,
  });

  const section1Ref = useRef(null);
  const section2Ref = useRef(null);
  const section3Ref = useRef(null);
  const section4Ref = useRef(null);
  const section5Ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.getAttribute("id");
          if (entry.isIntersecting) {
            switch (id) {
              case "section1":
                setIsScrolledToSection({
                  section5: false,
                  section1: true,
                  section2: false,
                  section3: false,
                  section4: false,
                });
                break;
              case "section2":
                setIsScrolledToSection({
                  section5: false,
                  section1: true,
                  section2: true,
                  section3: false,
                  section4: false,
                });
                break;
              case "section3":
                setIsScrolledToSection({
                  section5: false,
                  section1: true,
                  section2: true,
                  section3: true,
                  section4: false,
                });
                break;
              case "section4":
                setIsScrolledToSection({
                  section5: false,
                  section1: true,
                  section2: true,
                  section3: true,
                  section4: true,
                });
                break;
              case "section5":
                setIsScrolledToSection({
                  section5: true,
                  section1: true,
                  section2: true,
                  section3: true,
                  section4: true,
                });
                break;
              default:
                return;
                break;
            }
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    const sections = [
      section1Ref,
      section2Ref,
      section3Ref,
      section4Ref,
      section5Ref,
    ];
    sections.forEach((sectionRef) => {
      if (sectionRef.current) {
        observer.observe(sectionRef.current);
      }
    });

    return () => {
      sections.forEach((sectionRef) => {
        if (sectionRef.current) {
          observer.unobserve(sectionRef.current);
        }
      });
    };
  }, [isScrolledToSection]);

  return (
    <>
      <Helmet>
        <title>
          Union Center | Modern Office Space in Downtown Flushing, NY
        </title>
        <meta
          name="description"
          content="Discover Union Center, a 15-story modern office building in Downtown Flushing featuring state-of-the-art amenities, sustainable design, and prime location near public transportation."
        />
        <meta
          name="keywords"
          content="Union Center Flushing, modern office space, commercial real estate Queens, sustainable building NYC"
        />
      </Helmet>
      <div className="flex flex-col">
        <section className=" bg-background border-0 border-solid border-gray-300">
          <div className="w-full h-screen">
            <img
              src="img/resources/union_side.jpg"
              alt="Welcome to Union Center of Flushing"
              className="h-full w-full object-cover relative"
            />
          </div>
        </section>
        <div className="w-full py-20 bg-[#F0EDE8] text-black">
          <section
            className="max-w-[1290px] px-10 border-0 border-solid border-gray-300"
            style={{
              textAlign: "center",
              marginLeft: "auto",
              marginRight: "auto",
              fontSize: "1.125rem",
              lineHeight: "1.75rem",
              fontWeight: "400",
              color: "black",
            }}
          >
            <div className="max-w-[980px] md:mx-[115px]">
              <div
                className={`${
                  isScrolledToSection.section1
                    ? "top-0 opacity-100"
                    : "top-24 opacity-0"
                } transition-all duration-[800ms]  relative`}
              >
                <p className=" max-w-[980px]  text-lg text-[#b98953] font-roboto">
                  WELCOME TO UNION CENTER
                </p>
                <div ref={section1Ref} id="section1"></div>
                <h2 className=" max-w-[980px] text-[#7e6140] mt-3 pb-[12px] text-5xl font-normal font-roboto">
                  World-Class Workplace
                </h2>
                <p className=" max-w-[980px] contrast-[21] mt-[30px] text-lg text-[#00000]">
                  Located in the heart of Flushing’s vibrant downtown business
                  district, Union Center presents a 133,000 SF state-of-the-art
                  build- to-suit Class A offices for young professionals seeking
                  an opportunity to invest in their professional future.
                </p>
              </div>
            </div>
          </section>
          {/* <div className="w-full">
            <img
              src="img/resources/Lobby_view1.jpg"
              alt="Morgan North"
              className=" w-full mt-[90px] max-h-[800px] object-cover"
            />
          </div> */}
          <PanoramaViewer />
        </div>
        <div className="w-full pt-0 text-[#00000] bg-[#F0EDE8]">
          <section className="max-w-[1290px] text-base ml-auto mr-auto px-10 -mb-2 font-roboto">
            <div
              className={`max-w-[980px] text-lg ml-auto text-right relative ${
                isScrolledToSection.section2
                  ? "top-0 opacity-100"
                  : "top-24 opacity-0"
              } transition-all duration-[800ms]`}
            >
              <p className="max-w-[980px] text-[#b98953] text-base">EXPLORE</p>
              <div ref={section2Ref} id="section2"></div>
              <h2 className="max-w-[980px] text-[#7e6140] text-5xl font-normal font-roboto">
                Modern Design
                <br />
                Meets Functionality
              </h2>
            </div>
          </section>
          <section className="w-full block mt-[100px]">
            <div className="w-full bg-[#c7ad90] relative">
              <div
                ref={section3Ref}
                id="section3"
                className="absolute top-[60px]"
              ></div>
              <div className="grid grid-cols-2 md:flex md:justify-center gap-8 md:gap-14 px-0 md:px-8 pt-10 pb-6">
                <LinkCart
                  className={`${
                    isScrolledToSection.section3
                      ? "top-0 opacity-100"
                      : "top-[60px] opacity-0"
                  } transition-all duration-[500ms] relative`}
                  img={Building}
                  name={"The Building"}
                  link="/building"
                />
                <LinkCart
                  className={`${
                    isScrolledToSection.section3
                      ? "top-0 opacity-100"
                      : "top-[120px] opacity-0"
                  } transition-all duration-[750ms] relative`}
                  img={Flushing}
                  name={"Neighborhood"}
                  link="/neighborhood"
                />
                <LinkCart
                  className={`${
                    isScrolledToSection.section3
                      ? "top-0 opacity-100"
                      : "top-[180px] opacity-0"
                  } transition-all duration-[1000ms] relative`}
                  img={Availability}
                  name={"Availability"}
                  link="/availability"
                />
                <LinkCart
                  className={`${
                    isScrolledToSection.section3
                      ? "top-0 opacity-100"
                      : "top-[240px] opacity-0"
                  } transition-all duration-[1250ms] relative`}
                  img={Gallery}
                  name={"Gallery"}
                  link="/gallery"
                />
              </div>
            </div>
          </section>
        </div>
        <div className="w-full text-[#00000] text-base pb-20 bg-[#F0EDE8] pt-24">
          <section className="md:flex w-full">
            <div className="w-full justify-center opacity-100 transform-none ease-linear duration-[800ms] pointer-events-auto relative">
              <div
                ref={section4Ref}
                id="section4"
                className="absolute top-[240px]"
              ></div>
              <img
                src="img/resources/Corridor_view2new.jpg"
                title="The Building"
                className={`w-full max-h-[800px] object-cover ${
                  isScrolledToSection.section4
                    ? "top-0 opacity-100"
                    : "top-[270px] opacity-0"
                } transition-all duration-[800ms] relative`}
              />
            </div>
            <div className="w-full px-10 flex relative">
              <div
                className={`max-w-[557px] text-lg relative my-auto ${
                  isScrolledToSection.section5
                    ? "opacity-100 top-[0px]"
                    : "opacity-100 top-[40px]"
                } transition-all duration-[800ms] relative`}
              >
                <h2 className="max-w-[557px] pt-10 md:pt-0 font-normal text-[#7e6140] text-5xl pb-3">
                  A Space Where
                  <br />
                  The Sky Is The Limit
                </h2>
                <div
                  ref={section5Ref}
                  id="section5"
                  className="top-[40px] absolute"
                ></div>
                <Link
                  to={"/building"}
                  target=""
                  className=" max-w-[220px] items-center h-[32.38] text-[#b98953] text-lg mt-6 pb-2 flex flex-row relative w-fit arrow-btn font-bold font-roboto uppercase  gap-6"
                  isinline="false"
                  index="1"
                >
                  Learn More
                  <svg
                    className="block align-middle fill-none max-w-[22px] h-[11px] overflow-hidden tracking-[2.16px] uppercase font-bold text-ellipsis text-lg pointer-events-auto"
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="11"
                    viewBox="0 0 22 11"
                    fill="none"
                  >
                    <path
                      d="M16.0425 6.41748H0V4.58496H16.0425V0H16.5L22 5.34668V5.65332L16.5 11H16.0425V6.41748Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </Link>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
